import SecurityAdminUsersGroupsModule from "./SecurityAdminUsersGroupsModule";

import type { IEventChannel } from "@esWebAPI/es/model/Models";
import type AjaxRequestBroker from "@esWebAPI/es/AjaxRequestBroker";
import type CacheModule from "../CacheModule";

const es = global.es;

const USER_TYPE = {
    '1': 'PREMIUM',
    '2': 'STANDARD'
};

const PERMISSIONS: {[key:string]: string} = {
    '0': 'ACCESS_PUBLIC',
    '1': 'ACCESS_LOGGED_IN_USER',
    '2': 'ACCESS_TENANT_ADMIN',
    '3': 'TENANT_EDIT',
    '4': 'TENANT_DELETE',
    '5': 'ANALYSE',
    '6': 'CREATE_TERRITORIES',
    '7': 'ADMINISTER_USERS_GROUPS',
    '8': 'EXPORT',
    '9': 'PUBLISH',
    '10': 'UPLOAD',
    '11': 'ADVANCED_TERRITORY_FEATURES',
    //'12': 'SCHEDULED_UPDATES',
    //'13': 'WEBHOOKS',
    '14': 'CRM_INTEGRATION',
    '15': 'DRIVE_TIME',
    '16': 'SSO_CONFIG',
    '17': 'TERRITORY_OPTIMIZATION',
    '18': 'CREATE_SCHEDULE',
    '19': 'ROUTING_DAY_TRIP',
    '20': "AI_CHAT"
};

/**
 * @class SecurityAdminModule
 */
export default class SecurityAdminModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    usersGroups;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     * @param cache 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;
    
        this.usersGroups = new SecurityAdminUsersGroupsModule(eventChannel, rqBroker, resourceName + '/Users_Groups', cache);

        this.getUserTypes = this.getUserTypes.bind(this);
    }

    /**
     * List of all users types details.
     *
     * @returns a dfd promise
     */
    getUserTypes() {
        const url = es.api.getURL(this.resourceName) + "/user_types";

        return this.cache.doGet(this.rqBroker, this.resourceName, url, "_user_types").then((userTypes) => {
            return userTypes.map(ut => ({
                created : parseInt(ut.created),
                id : parseInt(ut.id),
                lastModified : parseInt(ut.lastModified),
                maxUsers : parseInt(ut.maxUsers),
                permissions : ut.permissions.map((pid) => PERMISSIONS["" + pid]),
                userType : USER_TYPE[ut.userType]
            }));
        });
    }
}
